// components/NotificationProvider.tsx
import React from 'react';
import { Snackbar, Alert, IconButton, Slide } from '@mui/material';
import { XClose } from '@untitledui-pro/icons/line';
import useNotificationStore from '../../store/notification';

const NotificationProvider: React.FC = () => {
    const { notifications, dismissNotification } = useNotificationStore();

    if (notifications.length === 0) return null;

    const handleClose = (id: string) => (_event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') return;
        dismissNotification(id);
    };

    return (
        <>
            {notifications.map((notification, index) => {
                const { id, message, severity, closable, persistent } = notification;
                const autoHideDuration = persistent ? null : 5000;
                const visualIndex = notifications.length - 1 - index;
                const bottomOffset = 16 + visualIndex * 56;

                return (
                    <Snackbar
                        key={id}
                        open
                        autoHideDuration={autoHideDuration}
                        onClose={handleClose(id)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        slots={{ transition: Slide }}
                        slotProps={{ transition: { direction: 'up', timeout: { enter: 250, exit: 200 } } }}
                        style={{ bottom: bottomOffset, transition: 'bottom 220ms ease' }}
                    >
                        <Alert
                            sx={{ whiteSpace: 'pre-line' }}
                            severity={severity}
                            onClose={closable !== true ? () => dismissNotification(id) : undefined}
                            action={
                                closable ? (
                                    <IconButton size="small" aria-label="close" color="inherit" onClick={() => dismissNotification(id)}>
                                        <XClose />
                                    </IconButton>
                                ) : undefined
                            }
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                );
            })}
        </>
    );
};

export default NotificationProvider;
